import { render, staticRenderFns } from "./cropUpload.vue?vue&type=template&id=626c1641&"
import script from "./cropUpload.vue?vue&type=script&lang=js&"
export * from "./cropUpload.vue?vue&type=script&lang=js&"
import style0 from "./cropUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('626c1641')) {
      api.createRecord('626c1641', component.options)
    } else {
      api.reload('626c1641', component.options)
    }
    module.hot.accept("./cropUpload.vue?vue&type=template&id=626c1641&", function () {
      api.rerender('626c1641', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cropUpload.vue"
export default component.exports